import { message } from "antd";
import { token } from "../../constants/Constants";
import { fetch_all_coupons } from "../../endpoints/API";

export const fetchCoupons = async (setCoupons, baseUrl, prodTestUrl) => {
  try {
    const response = await fetch_all_coupons();
    if (response.statusText=="OK") {
      const data = response?.data;
      setCoupons(data);
    } else {
      message.error("Failed to fetch coupons.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching coupons.");
  }
};
